import { render, staticRenderFns } from "./ConfirmPasswordForm.vue?vue&type=template&id=2b78bbba&scoped=true&"
import script from "./ConfirmPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPasswordForm.vue?vue&type=style&index=0&id=2b78bbba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78bbba",
  null
  
)

export default component.exports